import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { fmtDateMed, fmtTime } from "../../lib/dates";

/**
 * Lets the admin pick a shift for a specific (employee, date) cell.
 * Triggered by clicking an empty cell in the roster grid.
 */
export const AddEntryDialog = ({ entry, shifts, getEmployeeName, onSelect, onClose }) => (
  <Dialog open={!!entry} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="text-lg tracking-tight font-bold">Add Shift Entry</DialogTitle>
      </DialogHeader>
      {entry && (
        <div className="space-y-3 mt-3">
          <div className="bg-zinc-50 dark:bg-zinc-800/50 border border-zinc-200 dark:border-zinc-800 p-3 rounded">
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">Assigning to</p>
            <p className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
              {getEmployeeName(entry.employee_id)} — {fmtDateMed(entry.date)}
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400 mb-2">Select Shift</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {shifts.map((shift) => (
                <button
                  key={shift.shift_id}
                  onClick={() => onSelect(entry.employee_id, entry.date, shift.shift_id)}
                  className="w-full flex items-center gap-3 p-3 border border-zinc-200 dark:border-zinc-800 rounded hover:border-[#002FA7] hover:bg-blue-50/30 transition-colors text-left"
                  data-testid={`select-shift-${shift.shift_id}`}
                >
                  <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: shift.color }} />
                  <div>
                    <p className="text-sm font-medium text-zinc-900 dark:text-zinc-100">{shift.name}</p>
                    <p className="text-xs text-zinc-500 dark:text-zinc-400">{fmtTime(shift.start_time)} — {fmtTime(shift.end_time)}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
